import { Button } from 'components'
import React from 'react'
import { setCustomTestCase, useAlgoEditorState, useAppDispatch } from 'state'

function CustomTestCaseTab({
  handleRunCode
}: {
  handleRunCode: (_: boolean) => void
}) {
  const { customTestCase } = useAlgoEditorState()
  const dispatch = useAppDispatch()

  return (
    <div className="py-2 w-full h-full">
      <textarea
        rows={5}
        maxLength={255}
        className="w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border-zinc-700 bg-zinc-900 rounded-md"
        placeholder="Test Case"
        name="custom_input"
        value={customTestCase}
        onChange={(e) => {
          dispatch(setCustomTestCase(e.target.value))
        }}
      />

      <Button
        className="text-sm py-1.5 px-2 ml-auto mt-3 bg-zinc-700 whitespace-nowrap"
        onClick={() => {
          handleRunCode(true)
        }}>
        Run Custom Testcases
      </Button>
    </div>
  )
}

export default CustomTestCaseTab
